import { useCallback, useState } from "react";
import { notification } from "antd";

export function handleError(err) {
  if (err?.message) {
    notification.error({
      message: err?.message,
      placement: "top",
    });
  } else {
    notification.error({
      message: "Something went wrong",
      placement: "top",
    });
  }
}
const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  //hàm sendRequest với 2 params, requestConfig là 1 mảng chứa thông tin url, method, headers, body; applyData là hàm xử lý data trả về từ fetch
  const sendRequest = useCallback(async (requestConfig, applyData) => {
    //đặt trạng thái đang fetch là true, error hiện tại là null
    setIsLoading(true);
    setError(null);
    try {
      ///fetch với các config được truyền vào,
      const res = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: requestConfig.headers ? requestConfig.headers : {},
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      const data = await res.json();
      //gọi hàm applyData và truyền vào data
      applyData(data);
    } catch (err) {
      console.log(err);
      //thông báo lỗi quá trình fetch
      setError(err);
    }
    //đặt lại Isloading là false khi quá trình fetch xong
    setIsLoading(false);
  }, []);

  //trả về trạng thái isLoading, error, và hàm sendRequest(config, applyData)
  return {
    isLoading,
    error,
    sendRequest,
  };
};

export const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: token ? "Bearer " + token : "",
  };
};

export const saveUserInfo = (data) => {
  return window.localStorage.setItem("user_info", JSON.stringify(data));
};

export const getUserInfo = () => {
  const data = window.localStorage.getItem("user_info");
  if (!data) return null;

  try {
    const parsedData = JSON.parse(data);
    if (
      parsedData &&
      typeof parsedData === "object" &&
      !Array.isArray(parsedData) &&
      parsedData.id
    ) {
      return parsedData;
    }
  } catch (error) {
    // Ignore invalid cached auth data and let the app request login again.
  }

  window.localStorage.removeItem("user_info");
  return null;
};

export const saveTableInfo = (data) => {
  return window.localStorage.setItem("TABLEID", JSON.stringify(data));
};

export const getTableInfo = () => {
  const data = window.localStorage.getItem("TABLEID");
  return data ? JSON.parse(data) : null;
};

export const saveLocale = (data) => {
  return window.localStorage.setItem("LOCALE", JSON.stringify(data));
};

export const getLocale = () => {
  const data = window.localStorage.getItem("LOCALE");
  return data ? JSON.parse(data) : null;
};

// New functions for JWT authentication
export const saveToken = (token) => {
  return window.localStorage.setItem("token", token);
};

export const getToken = () => {
  return window.localStorage.getItem("token");
};

// Stream token storage
export const saveStreamToken = (token) => {
  return window.localStorage.setItem("streamToken", token);
};

export const getStreamToken = () => {
  return window.localStorage.getItem("streamToken");
};

export const saveStreamInfo = (data) => {
  return window.localStorage.setItem("stream_info", JSON.stringify(data));
};

export const getStreamInfo = () => {
  const data = window.localStorage.getItem("stream_info");
  return data ? JSON.parse(data) : null;
};

export const clearAuth = () => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("user_info");
  window.localStorage.removeItem("streamToken");
  window.localStorage.removeItem("stream_info");
};

export default useHttp;
